import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

interface NavbarProps {
  transparent?: boolean;
}

export default function Navbar({ transparent = false }: NavbarProps) {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const isTransparent = transparent && !scrolled;

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isTransparent
          ? 'bg-transparent'
          : 'bg-background-50 border-b border-background-200/70'
      }`}
    >
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <span
              className={`text-xl md:text-2xl font-bold ${
                isTransparent ? 'text-white' : 'text-foreground-950'
              }`}
              style={{ fontFamily: 'var(--font-heading)' }}
            >
              羞羞漫画
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname === '/'
                  ? isTransparent
                    ? 'text-white font-semibold'
                    : 'text-primary-500 font-semibold'
                  : isTransparent
                    ? 'text-white/80 hover:text-white'
                    : 'text-foreground-700 hover:text-primary-500'
              }`}
            >
              首页
            </Link>
            <Link
              to="/category/all"
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname.startsWith('/category')
                  ? isTransparent
                    ? 'text-white font-semibold'
                    : 'text-primary-500 font-semibold'
                  : isTransparent
                    ? 'text-white/80 hover:text-white'
                    : 'text-foreground-700 hover:text-primary-500'
              }`}
            >
              分类浏览
            </Link>
            <Link
              to="/category/lianzai"
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isTransparent ? 'text-white/80 hover:text-white' : 'text-foreground-700 hover:text-primary-500'
              }`}
            >
              连载中
            </Link>
            <Link
              to="/category/wanjie"
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isTransparent ? 'text-white/80 hover:text-white' : 'text-foreground-700 hover:text-primary-500'
              }`}
            >
              已完结
            </Link>
            <Link
              to="/about"
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname === '/about'
                  ? isTransparent
                    ? 'text-white font-semibold'
                    : 'text-primary-500 font-semibold'
                  : isTransparent
                    ? 'text-white/80 hover:text-white'
                    : 'text-foreground-700 hover:text-primary-500'
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/category/all"
              className="px-5 py-2 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              开始阅读
            </Link>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i
              className={`text-xl ${
                isTransparent ? 'text-white' : 'text-foreground-950'
              } ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}
            ></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 px-4 py-4">
          <div className="flex flex-col gap-3">
            <Link to="/" className="text-foreground-950 text-sm font-medium py-2 cursor-pointer">首页</Link>
            <Link to="/category/all" className="text-foreground-950 text-sm font-medium py-2 cursor-pointer">分类浏览</Link>
            <Link to="/category/lianzai" className="text-foreground-950 text-sm font-medium py-2 cursor-pointer">连载中</Link>
            <Link to="/category/wanjie" className="text-foreground-950 text-sm font-medium py-2 cursor-pointer">已完结</Link>
            <Link to="/about" className="text-foreground-950 text-sm font-medium py-2 cursor-pointer">关于我们</Link>
            <Link
              to="/category/all"
              className="px-5 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-medium text-center hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              开始阅读
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}